
import { Dialog, DialogContent } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { ArrowLeft } from "lucide-react";

interface LoungeDialogProps {
  showLounge: boolean;
  setShowLounge: (show: boolean) => void;
  flightDepartureCode?: string;
}

export function LoungeDialog({
  showLounge,
  setShowLounge,
  flightDepartureCode
}: LoungeDialogProps) {
  return (
    <Dialog open={showLounge} onOpenChange={setShowLounge}>
      <DialogContent className="sm:max-w-[90vw] h-[90vh] p-0">
        <div className="sticky top-0 z-50 bg-background border-b p-4 flex items-center gap-2">
          <Button variant="ghost" onClick={() => setShowLounge(false)} className="gap-2">
            <ArrowLeft className="h-4 w-4" />
            Back to Trip Details
          </Button>
        </div>
        <div className="h-[calc(90vh-60px)]">
          <iframe src={`https://www.prioritypass.com/en/lounges/${flightDepartureCode?.toLowerCase()}`} className="w-full h-full" title="Airport Lounge Information" />
        </div>
      </DialogContent>
    </Dialog>
  );
}
